<template>
  <div class="pt-40">
    <Head title="登入" />
    <div
      class="flex flex-col sm:justify-center items-center max-w-md mx-auto card"
    >
      <div class="w-full">
        <div class="mx-auto">
          <div
            v-if="$page.props.errors.auth_failed"
            class="text-red text-center mt-10"
          >
            {{ $page.props.errors.auth_failed }}
          </div>
          <div class="form_element">
            <div class="label">
              <label for="name">帳號</label>
            </div>
            <div class="input">
              <InputText id="name" type="text" v-model="form.username" />
              <div v-if="$page.props.errors.username" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.username }}
              </div>
            </div>
          </div>
          <div class="form_element">
            <div class="label">
              <label for="password">密碼</label>
            </div>
            <div class="input">
              <Password
                id="password"
                :feedback="false"
                v-model="form.password"
              />
              <div v-if="$page.props.errors.password" class="error_information">
                <i class="pi pi-arrow-up" /> {{ $page.props.errors.password }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="w-11/12 mx-auto text-fh-gray-light" />
      <div class="flex flex-col my-10 justify-center items-center">
        <div class="mt-5 text-center">
          <Button
            label="登入"
            icon="pi pi-check"
            iconPos="left"
            @click="submit"
          />
          <!-- <div class="mt-5 text-sm">
            <Link :href="route('password.request')">忘記密碼嗎？</Link>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/BlankLayout";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Button from "primevue/button";

export default {
  layout: Layout,
  components: {
    InputText,
    Password,
    Button,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    submit() {
      this.$inertia.post(route("admin.login"), _.pickBy(this.form), {
        preserveScroll: true,
      });
    },
  },
};
</script>

<style lang="postcss">
.card {
  @apply border border-solid border-fh-gray-light;
}

.tab {
  @apply border-solid border-fh-gray-light w-1/2 text-center p-4;
}

.form_element {
  @apply my-10 flex flex-row items-center;
}

.form_element .label {
  @apply text-right w-1/3 mr-5 text-sm;
}

.form_element .input {
  @apply text-left w-2/3;
}

.error_information {
  @apply text-red mt-1 pl-1;
}
</style>